import { render } from "./Vraag.vue?vue&type=template&id=57d50600"
import script from "./Vraag.vue?vue&type=script&lang=js"
export * from "./Vraag.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__